module.exports = __webpack_public_path__ + "img/sn.c1a6798a.svg";